import React, { ButtonHTMLAttributes, ReactNode } from 'react';

type FormButtonVariants = 'default' | 'secondary' | 'tertiary';

export interface FormButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  variant: FormButtonVariants;
}

/* Default styles for form buttons */
const formButtonPrimaryStyle = `px-4 py-1.75 bg-thryv-white-300 rounded text-btn-text text-thryv-cornflower-500 font-open-sans font-semibold capitalize 
  hover:bg-thryv-gray-medium-100 disabled:bg-thryv-gray-light-500 disabled:text-white`;

/* Secondary styles for form buttons */
const formButtonSecondaryStyle = `px-4 py-2 bg-thryv-white-300 rounded-full text-btn-text text-thryv-cornflower-500 font-open-sans font-semibold capitalize 
hover:bg-thryv-gray-medium-100 disabled:bg-thryv-gray-light-500 disabled:text-white`;

/* Third styles for form buttons */
const formButtonTerTiaryStyle = `px-4 py-1.75 bg-thryv-gray-light-200 rounded text-third-btn text-black font-open-sans font-normal uppercase 
hover:bg-thryv-gray-medium-200 disabled:bg-thryv-gray-light-500 disabled:text-white`;

export const FormButton = ({
  children,
  className,
  disabled = false,
  variant,
  type = 'button',
  ...rest
}: FormButtonProps) => (
  <button
    type={type}
    disabled={disabled}
    className={`${variant === 'default' ? formButtonPrimaryStyle : ''} 
  ${
    variant === 'secondary'
      ? `${formButtonSecondaryStyle} ${className && className}`
      : ''
  } 
  ${
    variant === 'tertiary'
      ? `${formButtonTerTiaryStyle} ${className && className}`
      : ''
  } transition duration-200 ease-in-out`}
    {...rest}
  >
    {children}
  </button>
);
